export const trackRegisterClick = (source: string) => {
  if (window.gtag) {
    window.gtag('event', 'register_click', {
      source: source,
    });
  }
};

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}
